// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__eEZZ7","name":"styles_name__18AOJ"};